import React from "react";
import { SourceCard } from "./SourceCard";
import styles from "./Sources.module.scss";
import { NormalizedSource } from "../../utils";

export const SourcesGallery: React.FC<{ sources: NormalizedSource[]}> = ({ sources }) => {
  if (!sources?.length) return null;
  return (
    <div className={styles.wrap} aria-label="Sources">
      {sources.map((s, i) => (
        <SourceCard key={`${s.url}-${i}`} {...s} />
      ))}
    </div>
  );
};